import { Link } from "react-router-dom";
import type { NewsItem } from "@/types";

const categoryStyle: Record<string, string> = {
  资讯: "bg-primary-100 text-primary-800",
  影评: "bg-accent-100 text-accent-900",
  行业动态: "bg-secondary-200 text-secondary-900",
};

export default function NewsCard({ item }: { item: NewsItem }) {
  return (
    <Link
      to={`/detail/news/${item.id}`}
      className="group flex flex-col bg-background-50 rounded-lg overflow-hidden border border-background-200 hover:border-primary-300 transition-all duration-300 cursor-pointer"
    >
      <div className="relative w-full aspect-[16/10] overflow-hidden bg-secondary-200">
        <img
          src={item.cover}
          alt={`${item.title} 资讯配图`}
          title={`${item.title} 电影资讯 91电影`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <span
          className={`absolute top-3 left-3 text-xs font-bold rounded-md px-2 py-1 ${
            categoryStyle[item.category] ?? categoryStyle["资讯"]
          }`}
        >
          {item.category}
        </span>
      </div>
      <div className="p-4 flex flex-col flex-1">
        <h3 className="font-heading font-bold text-base text-foreground-950 leading-snug line-clamp-2 group-hover:text-primary-700 transition-colors">
          {item.title}
        </h3>
        <p className="text-sm text-foreground-500 mt-2 line-clamp-2 flex-1">{item.excerpt}</p>
        <div className="flex items-center justify-between mt-4 text-xs text-foreground-400">
          <span className="flex items-center gap-1">
            <i className="ri-user-line" />
            {item.author}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-time-line" />
            {item.date}
          </span>
        </div>
      </div>
    </Link>
  );
}